<ng-container *transloco="let t">
  @if (hasTransferIntegration()) {
    @if (showPayerField()) {
      <pxw-input-text
        name="transferPayerDocument"
        inputMode="numeric"
        [label]="t('endOrder.transferPayerDocumentLabel')"
        [helper]="t(payerFieldHelperKey())"
        [mask]="payerDocumentMask"
        required
        [custom]="payerFieldValidator()"
        [displayErrors]="displayPayerFieldErrors()"
        [messages]="{
          required: t('validation.required'),
          invalidDocument: t('validation.invalidMask'),
          payerNotFound: t('endOrder.transferPayerNotFound'),
          payerNotChangeable: t('endOrder.transferPayerNotChangeable'),
        }"
        [ngModel]="payerDocumentInput()"
        (ngModelChange)="onPayerDocumentChange($event)"
      >
        @if (cvuLoading()) {
          <div class="addon-append payer-addon">
            <pxw-icon icon="loading" size="sm" [spin]="true" />
          </div>
        } @else if (resolvedPayerShortName(); as payerName) {
          <div class="addon-append payer-addon">
            <span class="payer-check">
              <pxw-icon icon="check" size="xxs" color="white" />
            </span>
            <span class="payer-name">{{ payerName }}</span>
          </div>
        }
      </pxw-input-text>
    } @else {
      @if (showPayerAlert()) {
        <pxw-alert type="success" size="sm" display="inline">
          @if (storedPayerName(); as storedPayerName) {
            {{ t('endOrder.transferPayerAs', { name: storedPayerName }) }}
          } @else {
            {{ t('endOrder.transferPayerWithDocument', { document: storedPayerDocument() }) }}
          }
          <ng-template #alertActions>
            <pxw-button
              color="emerald"
              appareance="outline"
              size="sm"
              [rounded]="true"
              (click)="onChangePayer()"
            >
              {{ t('endOrder.transferPayerChange') }}
            </pxw-button>
          </ng-template>
        </pxw-alert>
      }

      @if (cvuLoading()) {
        <pxw-alert type="neutral" size="sm" display="inline">
          <pxw-icon icon="loading" [spin]="true" />
          {{ t('endOrder.transferGeneratingCvu') }}
        </pxw-alert>
      } @else if (cvuData()) {
        @if (showTransferDetails()) {
          <pxw-transfer-details-card
            [data]="{
              cvu: cvuData()!.cvu,
              alias: cvuData()!.alias,
              accountHolder: cvuData()!.accountHolder,
            }"
          />
        } @else {
          <pxw-alert type="info" size="sm" display="inline">
            <pxw-icon icon="info" #customIcon></pxw-icon>
            {{ t('endOrder.transferCvuReady') }}
          </pxw-alert>
        }
      }
    }
  }
</ng-container>
